import { render, staticRenderFns } from "./CardSie.vue?vue&type=template&id=1887542a&scoped=true&"
import script from "./CardSie.vue?vue&type=script&lang=ts&"
export * from "./CardSie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1887542a",
  null
  
)

export default component.exports